import { render, staticRenderFns } from "./incentivesList.vue?vue&type=template&id=c0125b0e&scoped=true&"
import script from "./incentivesList.vue?vue&type=script&lang=js&"
export * from "./incentivesList.vue?vue&type=script&lang=js&"
import style0 from "./incentivesList.vue?vue&type=style&index=0&id=c0125b0e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0125b0e",
  null
  
)

export default component.exports